<template>
  <div class="container" :class="(isMobile)?'mt-3':' mt-5'">
    <div v-if="channel">

      <div v-if="!isPreview">
        <!-- Поиск сверху -->
        <div class="row mb-3">
          <div class="col-12 searchbar-panel">
            <SearchBarComponent searchType="channel" :channelId="channel.id"/>
          </div>
        </div>
        
        <!-- Расширенные фильтры (скрыто) -->
        <div class="advanced-filters-bar mb-4" v-if="false">
          <div class="row align-items-center">
            <div class="col-md-2">
              <input 
                type="text" 
                class="form-control form-control-sm" 
                placeholder="Поиск по материалам..."
                v-model="materialFilters.query"
                @input="onFiltersChange"
              />
            </div>
            <div class="col-md-2">
              <TagsFilterWidget 
                :selected-tags="materialFilters.tags"
                @tags-selected="onTagsSelected"
              />
            </div>
            <div class="col-md-2">
              <LocationFilterWidget
                :selected-country="materialFilters.country"
                :selected-city="materialFilters.city"
                @location-selected="onLocationSelected"
              />
            </div>
            <div class="col-md-2">
              <AdditionalFiltersWidget
                :selected-level="materialFilters.audience_level"
                :selected-status="materialFilters.moderation_status"
                @level-selected="onAudienceLevelSelected"
                @status-selected="onModerationStatusSelected"
              />
            </div>
            <div class="col-md-2">
              <button 
                class="btn btn-outline-secondary btn-sm me-2" 
                @click="clearFilters"
                v-if="hasActiveFilters"
              >
                <i class="bi bi-x-circle"></i> Очистить
              </button>
            </div>
            <div class="col-md-2">
              <button 
                class="btn btn-outline-primary btn-sm" 
                @click="treeMode ? disableTreeMode() : enableTreeMode()"
              >
                <i :class="treeMode ? 'bi bi-list' : 'bi bi-calendar3'"></i>
                {{ treeMode ? 'Список' : 'Календарь' }}
              </button>
            </div>
          </div>
        </div>

        <!-- Двухколоночная структура -->
        <div class="row">
          <!-- Левая колонка: Календарное дерево (показывается в tree режиме или при активных фильтрах) -->
          <div 
            v-if="treeMode || hasActiveFilters" 
            class="col-md-3 calendar-sidebar"
          >
            <CalendarTreeComponent 
              :materials="filteredMaterials"
              :playlists="channel.collections || []"
              :is-loading="materialsLoading"
              @playlist-selected="onPlaylistSelected"
              @loose-materials-selected="onLooseMaterialsSelected"
              @year-selected="onYearSelected"
              @month-selected="onMonthSelected"
            />
          </div>
          
          <!-- Правая колонка: Основной контент -->
          <div :class="(treeMode || hasActiveFilters) ? 'col-md-9' : 'col-12'">
            <!-- Обычное содержимое канала (без фильтров и tree режима) -->
            <div v-if="!treeMode && !hasActiveFilters">
              <!-- Информация о канале -->
              <div class="row" :class="(isMobile)?'pt-4':''">
                <div class="col-12 col-md-4">
                  <img :src="channel.thumbs.big" class="mb-3 cover" v-if="channel.thumbs" />
                  
                  <!-- Компактная статистика под логотипом -->
                  <div v-if="showChannelStats" class="mb-4">
                    <ChannelStatsComponent :channelId="channel.id" />
                  </div>
                </div>
                <div class="col-12 col-md-8 d-flex align-items-center">
                  <div>
                    <div class="text-muted small" v-if="0">Автор: <a :href="'https://t.me/' + channel.username">{{channel.username}}</a></div>
                    <h1>{{ channel.caption }}</h1>
                    <div v-html="channel.description"></div>
                  </div>
                </div>
              </div>

              <!-- Плейлисты -->
              <div id="collections-list" class="mb-4" v-if="channel.collections.length">
                <h2>Плейлисты в канале</h2>
                <div class="row d-flex">
                  <div class="col-md-4" v-for="collection in channel.collections" :key="collection.id">
                    <div class="card mb-3 h-100">
                      <div class="card-body d-flex flex-column">
                        <div class="d-flex align-items-start mb-2">
                          <div class="mr-2" v-if="collection.thumbs.big">
                            <img :src="collection.thumbs.big" alt="" class="thumb">
                          </div>
                          <div class="thumb empty-thumb" v-if="!collection.thumbs.big">
                            <i class="bi bi-camera"></i>
                          </div>
                        </div>
                        <div>
                          <h4 class="card-title mb-1">
                            <router-link :to="{ name: 'Collection', params: { id: collection.hash } }">
                              {{ collection.caption }}
                            </router-link>
                          </h4>
                          <p v-if="collection.materials_count" class="card-text mb-0">{{ collection.materials_count }} материалов</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Курсы -->
              <div id="collections-list" class="mb-4" v-if="channel.courses.length">
                <h2>Курсы в канале</h2>
                <div class="row d-flex">
                  <div class="col-md-4" v-for="collection in channel.courses" :key="collection.id">
                    <div class="card mb-3 h-100">
                      <div class="card-body d-flex flex-column">
                        <div class="d-flex align-items-start mb-2">
                          <div class="mr-2" v-if="collection.thumbs.big">
                            <img :src="collection.thumbs.big" alt="" class="thumb">
                          </div>
                          <div class="thumb empty-thumb" v-if="!collection.thumbs.big">
                            <i class="bi bi-camera"></i>
                          </div>
                        </div>
                        <div>
                          <h4 class="card-title mb-1">
                            <router-link :to="{ name: 'Collection', params: { id: collection.hash } }">
                              {{ collection.caption }}
                            </router-link>
                          </h4>
                          <p v-if="collection.materials_count" class="card-text mb-0">{{ collection.materials_count }} материалов</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Материалы (обычный режим) -->
              <div class="mb-3">
                <h2>Материалы</h2>
                
                <!-- Табы Новые/Старые -->
                <ul class="nav nav-tabs">
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      :class="{ active: materialType === 'newest' }"
                      @click="selectMaterialType('newest')"
                      href="javascript:void(0);"
                    >Новые</a>
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      :class="{ active: materialType === 'oldest' }"
                      @click="selectMaterialType('oldest')"
                      href="javascript:void(0);"
                    >Старые</a>
                  </li>
                </ul>
              </div>
            </div>
            
            <!-- Отфильтрованные результаты -->
            <div v-else class="filtered-results">
              <div class="results-header mb-3">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <h3 class="mb-1">
                      <i class="bi bi-funnel me-2"></i>
                      Результаты поиска
                    </h3>
                    <p class="text-muted mb-0">
                      Найдено материалов: 
                      <strong>{{ (selectedPlaylist || selectedLooseMaterials) ? channel.materials?.length || 0 : filteredMaterials.length }}</strong>
                    </p>
                  </div>
                  <div>
                    <span v-if="selectedPlaylist" class="badge bg-warning text-dark">
                      <i class="bi bi-collection-play me-1"></i>
                      {{ selectedPlaylist.caption }}
                    </span>
                    <span v-if="selectedLooseMaterials" class="badge bg-info text-dark">
                      <i class="bi bi-file-earmark-play me-1"></i>
                      Отдельные материалы
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Категории (показываем в обычном режиме) -->
      <div v-if="!treeMode && !hasActiveFilters">
        <CategoryListComponent
          :categories="channel.categories"
          :selectedCategoryId="getSelectedCategoryId"
          :hasEditAccess="hasEditAccess"
          @select-category="selectCategory"
        />
      </div>

      <!-- Список материалов -->
      <div class="row row-cols-1 row-cols-md-3 g-4 materials-cards">
        <div v-for="material in channel.materials" :key="material.id" class="col">
          <MaterialCard
            :material="material"
            :isPreview="isPreview === true || isPreview === 'true'"
          />
        </div>
      </div>

      <div class="text-center">
        <spinner-component :visible="materialsLoading" class="mt-4"></spinner-component>
      </div>
    </div>
    <div v-else class="text-center">
      <spinner-component :visible="true"></spinner-component>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore, mapGetters } from 'vuex';
import SpinnerComponent from '@/components/SpinnerComponent.vue';
import CategoryListComponent from '@/components/CategoryListComponent.vue';
import SearchBarComponent from './SearchBarComponent.vue';
import ChannelStatsComponent from './ChannelStatsComponent.vue';
import MaterialCard from './MaterialCard.vue';
import CalendarTreeComponent from './CalendarTreeComponent.vue';
import TagsFilterWidget from './filter-widgets/TagsFilterWidget.vue';
import LocationFilterWidget from './filter-widgets/LocationFilterWidget.vue';
import AdditionalFiltersWidget from './filter-widgets/AdditionalFiltersWidget.vue';

export default {
  components: {
    SpinnerComponent,
    SearchBarComponent,
    CategoryListComponent,
    ChannelStatsComponent,
    MaterialCard,
    CalendarTreeComponent,
    TagsFilterWidget,
    LocationFilterWidget,
    AdditionalFiltersWidget
  },

  computed: {
    ...mapGetters('app', ['isMobile', 'configData', 'isPreview']),
    ...mapGetters('channel', ['getSelectedCategoryId'])
  },

  props: {
    id: {
      type: String,
      required: true
    }
  },

  setup(props) {
    const store = useStore();
    const route = useRoute();
    const channelId = ref(null);
    const channel = ref(null);
    const materialType = ref('newest');
    const materialsLoading = ref(false);
    const page = ref(1);
    const allLoaded = ref(false);
    
    // Расширенные фильтры для материалов
    const materialFilters = ref({
      query: '',
      year: '',
      month: '',
      country: '',
      city: '',
      tags: [],
      audience_level: '',
      moderation_status: '',
      festival_id: ''
    });
    
    // Состояния для календарного дерева
    const selectedPlaylist = ref(null);
    const selectedLooseMaterials = ref(null);
    const treeMode = ref(false); // false = обычный режим, true = режим календарного дерева
    
    const debounceTimer = ref(null);
    const hasEditAccess = computed(() => store.getters['user/hasEditAccess']);

    const fetchMaterials = () => {
      if (!channel.value || materialsLoading.value || allLoaded.value) return; // Проверка на наличие канала

      materialsLoading.value = true;
      const payload = {
        channelId: channel.value.id,
        materialsType: materialType.value,
        page: page.value,
        categoryId: store.state.channel.selectedCategoryId,  // Используем Vuex
        // Добавляем фильтры
        ...materialFilters.value
      };

      store.dispatch('channel/fetchChannelMaterials', payload)
        .then((data) => {
          if (data.channel_materials.length) {
            channel.value.materials.push(...data.channel_materials);
            page.value += 1;
          } else {
            allLoaded.value = true;
          }
          materialsLoading.value = false;
        })
        .catch((error) => {
          console.log(error);
          materialsLoading.value = false;
        });
    };

    const selectMaterialType = (type) => {
      materialType.value = type;
      store.dispatch('channel/selectCategory', { 
        categoryId: -1,  // Используем Vuex для сброса категории
        channelId: channel.value.id, 
        materialsType: materialType.value 
      });
      page.value = 0;
      allLoaded.value = false;
      channel.value.materials = [];
    };

    const selectCategory = (category) => {
      store.dispatch('channel/selectCategory', {
        categoryId: category.id,
        channelId: channel.value.id,
        materialsType: materialType.value
      });
    };

    const handleScroll = () => {
      const bottomOfWindow = window.innerHeight + window.scrollY >= document.body.offsetHeight;
      if (bottomOfWindow) {
        fetchMaterials();
      }
    };

    // Следим за изменениями выбранной категории и обновляем материалы
    watch(() => store.state.channel.selectedCategoryId, () => {
      page.value = 0;
      allLoaded.value = false;
      channel.value.materials = [];
      fetchMaterials();
    });

onMounted(() => {
  channelId.value = route.params.id;
  if (typeof props.id !== 'undefined' && props.id) {
    channelId.value = props.id;
  }

  let categoryId = route.query.categoryId;
  if (categoryId !== undefined) {
    categoryId = parseInt(categoryId) || 0; // Преобразуем только если categoryId имеет значимое значение, иначе ставим 0
    store.commit('channel/setSelectedCategory', categoryId); // Используем мутацию Vuex для установки категории
  } else {
    categoryId = 0;
  }

  store.dispatch('channel/fetchChannel', { channelId: channelId.value })
    .then((data) => {
      channel.value = data.channel;
      document.title = data.channel.caption;

      // Проверка на categoryId !== 0 перед отправкой запроса
      const requestParams = {
        channelId: data.channel.id,
        materialsType: materialType.value,
        ...(categoryId !== 0 && { categoryId }) // добавляем categoryId только если он не равен 0
      };

      //console.log(data.channel);

      store.dispatch('channel/fetchChannelMaterials', requestParams)
        .then((materialsData) => {
          channel.value.materials = materialsData.channel_materials;
        })
        .catch((error) => {
          console.log(error);
        });
    })
    .catch((error) => {
      console.log(error);
    });

  window.addEventListener('scroll', handleScroll);
});



    // Computed для проверки показа статистики канала через конфигурацию
    const showChannelStats = computed(() => {
      return store.getters['app/configData'] && store.getters['app/configData'].show_channel_stats;
    });

    // Computed для проверки активных фильтров
    const hasActiveFilters = computed(() => {
      const filters = materialFilters.value;
      return filters.query !== '' || filters.year !== '' || filters.month !== '' ||
             filters.country !== '' || filters.city !== '' || 
             filters.audience_level !== '' || filters.moderation_status !== '' ||
             filters.festival_id !== '' ||
             (filters.tags && filters.tags.length > 0) ||
             selectedPlaylist.value !== null || selectedLooseMaterials.value !== null;
    });
    
    // Computed для отфильтрованных материалов (для календарного дерева)
    const filteredMaterials = computed(() => {
      if (!channel.value?.materials) return [];
      
      let filtered = [...channel.value.materials];
      
      // Применяем текстовый поиск
      if (materialFilters.value.query) {
        const query = materialFilters.value.query.toLowerCase();
        filtered = filtered.filter(m => 
          m.title?.toLowerCase().includes(query) ||
          m.description?.toLowerCase().includes(query)
        );
      }
      
      // Применяем фильтр по тегам
      if (materialFilters.value.tags?.length > 0) {
        filtered = filtered.filter(m => 
          materialFilters.value.tags.some(tag => 
            m.tags?.includes(tag) || m.keywords?.includes(tag)
          )
        );
      }
      
      // Применяем фильтр по локации
      if (materialFilters.value.country || materialFilters.value.city) {
        filtered = filtered.filter(m => {
          const matchCountry = !materialFilters.value.country || m.country === materialFilters.value.country;
          const matchCity = !materialFilters.value.city || m.city === materialFilters.value.city;
          return matchCountry && matchCity;
        });
      }
      
      // Применяем фильтр по уровню подготовки
      if (materialFilters.value.audience_level) {
        filtered = filtered.filter(m => m.audience_level === materialFilters.value.audience_level);
      }
      
      // Применяем фильтр по модерации
      if (materialFilters.value.moderation_status) {
        filtered = filtered.filter(m => m.moderation_status === materialFilters.value.moderation_status);
      }
      
      // Применяем фильтр по фестивалю/плейлисту
      if (materialFilters.value.festival_id) {
        filtered = filtered.filter(m => m.collection_id === parseInt(materialFilters.value.festival_id));
      }
      
      return filtered;
    });

    // Computed для доступных годов
    const availableYears = computed(() => {
      const years = [];
      const currentYear = new Date().getFullYear();
      for (let year = currentYear; year >= 2010; year--) {
        years.push(year);
      }
      return years;
    });

    // Функция для обработки изменений фильтров с debounce
    const onFiltersChange = () => {
      if (debounceTimer.value) {
        clearTimeout(debounceTimer.value);
      }
      debounceTimer.value = setTimeout(() => {
        applyFilters();
      }, 500);
    };

    // Применение фильтров
    const applyFilters = () => {
      page.value = 0;
      allLoaded.value = false;
      if (channel.value) {
        channel.value.materials = [];
        fetchMaterials();
      }
    };

    // Очистка фильтров
    const clearFilters = () => {
      materialFilters.value = {
        query: '',
        year: '',
        month: '',
        country: '',
        city: '',
        tags: [],
        audience_level: '',
        moderation_status: '',
        festival_id: ''
      };
      selectedPlaylist.value = null;
      selectedLooseMaterials.value = null;
      treeMode.value = false;
      applyFilters();
    };
    
    // Обработчики календарного дерева
    const onPlaylistSelected = (playlist) => {
      selectedPlaylist.value = playlist;
      selectedLooseMaterials.value = null;
      treeMode.value = true;
      
      // Фильтруем материалы по выбранному плейлисту
      if (channel.value) {
        channel.value.materials = filteredMaterials.value.filter(m => 
          m.collection_id === playlist.id
        );
      }
    };
    
    const onLooseMaterialsSelected = ({ year, month, materials }) => {
      selectedLooseMaterials.value = `${year}-${month}`;
      selectedPlaylist.value = null;
      treeMode.value = true;
      
      // Показываем только отдельные материалы этого месяца
      if (channel.value) {
        channel.value.materials = materials;
      }
    };
    
    const onYearSelected = (year) => {
      console.log('Year selected:', year);
    };
    
    const onMonthSelected = ({ year, month }) => {
      console.log('Month selected:', year, month);
    };
    
    // Обработчики фильтров
    const onTagsSelected = (tags) => {
      materialFilters.value.tags = tags;
      onFiltersChange();
    };
    
    const onLocationSelected = ({ country, city }) => {
      materialFilters.value.country = country || '';
      materialFilters.value.city = city || '';
      onFiltersChange();
    };
    
    const onAudienceLevelSelected = (level) => {
      materialFilters.value.audience_level = level || '';
      onFiltersChange();
    };
    
    const onModerationStatusSelected = (status) => {
      materialFilters.value.moderation_status = status || '';
      onFiltersChange();
    };
    
    const onFestivalSelected = (festivalId) => {
      materialFilters.value.festival_id = festivalId || '';
      onFiltersChange();
    };
    
    // Переключение в режим календарного дерева
    const enableTreeMode = () => {
      treeMode.value = true;
    };
    
    const disableTreeMode = () => {
      treeMode.value = false;
      selectedPlaylist.value = null;
      selectedLooseMaterials.value = null;
      // Восстанавливаем исходные материалы
      if (channel.value) {
        fetchMaterials();
      }
    };

    return {
      channelId,
      channel,
      materialType,
      hasEditAccess,
      fetchMaterials,
      materialsLoading,
      page,
      allLoaded,
      selectCategory,
      selectMaterialType,
      showChannelStats,
      // Фильтры
      materialFilters,
      hasActiveFilters,
      availableYears,
      onFiltersChange,
      clearFilters,
      // Календарное дерево
      filteredMaterials,
      selectedPlaylist,
      selectedLooseMaterials,
      treeMode,
      onPlaylistSelected,
      onLooseMaterialsSelected,
      onYearSelected,
      onMonthSelected,
      onTagsSelected,
      onLocationSelected,
      onAudienceLevelSelected,
      onModerationStatusSelected,
      onFestivalSelected,
      enableTreeMode,
      disableTreeMode
    };
  },
};

</script>

<style>
.cover {
  width: 100% !important;
  height: auto;
  border-radius: 10px;
}

#collections-list {
  padding: 1rem;
  background: var(--yt-primary-light, #f4eeff);
  border-radius: 6px;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

#collections-list .thumb {
  width: 100%;
  height: auto;
}

#collections-list .thumb.empty-thumb {
  width: 100%;
  height: 120px;
}

.category-btn{
  display: flex;
  align-items: center;
}

.category-btn .caption{
  max-width: 120px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.9rem;
}

.searchbar-panel {
  /* Поисковая панель адаптируется в зависимости от состояния меню */
}

.menu-open .searchbar-panel {
  /* Стили для открытого состояния меню */
}

.menu-closed .searchbar-panel {
  /* Стили для закрытого состояния меню */
}

.isMobile .searchbar-panel {
  /* Стили для мобильных устройств */
}

/* Новые стили для календарной структуры */
.advanced-filters-bar {
  background: var(--yt-bg-secondary, #f8f9fa);
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid var(--yt-bg-tertiary, #e9ecef);
}

.calendar-sidebar {
  padding-right: 1rem;
}

.filtered-results .results-header {
  background: var(--yt-warning-light, #fff3cd);
  padding: 1rem;
  border-radius: 6px;
  border-left: 4px solid var(--yt-warning, #ffc107);
}

@media (max-width: 768px) {
  .calendar-sidebar {
    padding-right: 0;
    margin-bottom: 2rem;
  }
  
  .advanced-filters-bar .row > div {
    margin-bottom: 0.5rem;
  }
  
  .advanced-filters-bar .row > div:last-child {
    margin-bottom: 0;
  }
}
</style>